import Cookies from "js-cookie";
import router from "@/router";
import store from "@/store";
import { removeNotificationId } from "@/api/notification";
import Vue from "vue";

const TokenKey = "Admin-Token";
const FullNameKey = "fullName";
const NumSystemKey = "numSystem";
const Jensiat = "jensiat";
const UnreadKey = "unread";
const ImageKey = "image";
const URLKey = "url";

const FirebaseKey = "firebase";

export function getToken() {
  var token = Cookies.get("Admin-Token");
  return token != undefined && token != "" ? token : false;
}

export function getFullName() {
  var fullName = Cookies.get("fullName");
  return fullName != undefined ? fullName : "";
}

export function getNumSystem() {
  var numSystem = Cookies.get("numSystem");
  return numSystem != undefined ? numSystem : "";
}

export function getJensiat() {
  var jensiat = Cookies.get("jensiat");
  return jensiat != undefined ? jensiat : "";
}

export function getUnread() {
  var unread = Cookies.get("unread");
  return unread != undefined ? parseInt(unread) : 0;
}

export function getReturnUrl() {
  var url = Cookies.get(URLKey);
  return url != undefined ? url : "/index";
}

export function getImage() {
  return Cookies.get("image");
}

export function getFirebase() {
  var firebase = Cookies.get(FirebaseKey);
  return firebase != undefined && firebase != "" ? firebase : false;
}

export function setToken(token) {
  Cookies.set(TokenKey, token, { sameSite: "None", secure: true });
}

export function setFirebase(firebase) {
  Cookies.set(FirebaseKey, firebase, { sameSite: "none", secure: true });
}

export function setUrlKey(url) {
  Cookies.set(URLKey, url, { sameSite: "none", secure: true });
}

export function setSlider(fullName, numSystem, unread, imageUrl, jensiat) {
  Cookies.set(FullNameKey, fullName, { sameSite: "none", secure: true });
  Cookies.set(NumSystemKey, numSystem, { sameSite: "none", secure: true });
  Cookies.set(Jensiat, jensiat, { sameSite: "none", secure: true });
  Cookies.set(UnreadKey, unread, { sameSite: "none", secure: true });
  Cookies.set(ImageKey, imageUrl, { sameSite: "none", secure: true });
}

export function removeToken() {
  Cookies.remove(FullNameKey, { sameSite: "none", secure: true });
  Cookies.remove(NumSystemKey, { sameSite: "none", secure: true });
  Cookies.remove(Jensiat, { sameSite: "none", secure: true });
  Cookies.remove(UnreadKey, { sameSite: "none", secure: true });
  Cookies.remove(ImageKey, { sameSite: "none", secure: true });
  Cookies.remove(FirebaseKey, { sameSite: "none", secure: true });
  Cookies.remove(TokenKey, { sameSite: "none", secure: true });
  Cookies.remove("idsrv.session");
}

export function removeUrlKey() {
  Cookies.remove(URLKey, { sameSite: "none", secure: true });
}

export function logout() {
  if (getToken()) {
    if (getFirebase() == false) {
      store.dispatch("LogOut").then(() => {});
    } else {
      removeNotificationId(getFirebase()).then(() => {
        store.dispatch("LogOut").then(() => {});
      });
    }
  }
}
const whiteList = ["/loginWithOpenID", "/", ""]; // no redirect whitelist
const freeList = [
  "/salary",
  "/messages",
  "/registers",
  "/registers-history",
  "/links",
  "/index",
  "/contactus",
  "/new-contact-v2",
  "/contacts",
  "/jazb",
  "/jazb-history",
  "/ezam",
  "/ezam-history"

];
router.beforeEach((to, from, next) => {
  store.commit("SET_PROGRESS_SHOW", false);

  if (
    whiteList.indexOf(to.path) == -1 &&
    to.path != "/contactus" &&
    !getToken()
  ) {
    setUrlKey(to.path);

    next({ name: "OpenID" });
  } else if (whiteList.indexOf(to.path) !== -1 && getToken()) {
    next({ name: "Index" });
  } else if (getToken()) {
    store.dispatch("GetUserInfo").then(() => {
      if (!store.getters.userInfo.FardID) {
        logout();
      }
      if (
        !store.getters.userInfo.Active &&
        freeList.indexOf(to.path) == -1 &&
        whiteList.indexOf(to.path) == -1
      ) {
        next({ name: "Index" });
      } else {
        next();
      }
    });
  } else {
    next();
  }
});

router.afterEach((to, from) => {
  Vue.nextTick(() => {
    document.title = to.meta.title || "طلوع";
  });
});
